/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./scripts/sections/footer.js":
/*!************************************!*\
  !*** ./scripts/sections/footer.js ***!
  \************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _footerAnimation_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./footerAnimation.js */ "./scripts/sections/footerAnimation.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



var Footer = /*#__PURE__*/function () {
  function Footer() {
    _classCallCheck(this, Footer);

    this.footerAnimation = new _footerAnimation_js__WEBPACK_IMPORTED_MODULE_0__["FooterAnimation"]();
    this.handleMobileMenus();
  }

  _createClass(Footer, [{
    key: "handleMobileMenus",
    value: function handleMobileMenus() {
      if (!document.querySelectorAll('.menu-mobile-title').length) return;
      document.querySelectorAll('.menu-mobile-title').forEach(function (title) {
        var column = title.closest('.col');
        var menuList = column.querySelector('.menu-wrapper');
        var menuHeight = column.querySelector('.menu').clientHeight;
        title.addEventListener('click', function () {
          if (title.classList.contains('active')) {
            title.classList.remove('active');
            menuList.style.height = 0;
          } else {
            title.classList.add('active');
            menuList.style.height = "".concat(menuHeight, "px");
          }
        });
      });
    }
  }]);

  return Footer;
}();

new Footer();

/***/ }),

/***/ "./scripts/sections/footerAnimation.js":
/*!*********************************************!*\
  !*** ./scripts/sections/footerAnimation.js ***!
  \*********************************************/
/*! exports provided: FooterAnimation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FooterAnimation", function() { return FooterAnimation; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var MathUtils = {
  // map number x from range [a, b] to [c, d]
  map: function map(x, a, b, c, d) {
    return (x - a) * (d - c) / (b - a) + c;
  }
};
var FooterAnimation = /*#__PURE__*/function () {
  function FooterAnimation() {
    var _this = this;

    _classCallCheck(this, FooterAnimation);

    this.breakpoint = window.matchMedia("(min-width:1025px)");

    if (this.breakpoint.matches === true) {
      this.DOM = {
        element: document.querySelector('.footer')
      };
      this.DOM.innerElement = this.DOM.element.querySelector('.footer-inner');
      this.state = {
        isAnimated: false,
        mapStart: 0,
        mapEnd: 0,
        transformStart: 0,
        elementHeight: 0
      };
      this.update = this.update.bind(this);
      this.render = this.render.bind(this);
      this.tick = this.tick.bind(this);
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          _this.state.isAnimated = entry.isIntersecting;
        });
      }).observe(this.DOM.element);
      new ResizeObserver(function () {
        _this.update();

        _this.render();
      }).observe(document.body);
      this.bindEvents();
    }
  }

  _createClass(FooterAnimation, [{
    key: "bindEvents",
    value: function bindEvents() {
      window.addEventListener('scroll', this.tick);
      window.addEventListener('load', this.update);
    }
  }, {
    key: "absoluteOffset",
    value: function absoluteOffset(element) {
      var top = 0;
      var left = 0;
      var currentElement = element;

      do {
        top += currentElement.offsetTop || 0;
        left += currentElement.offsetLeft || 0;
        currentElement = currentElement.offsetParent;
      } while (currentElement);

      return {
        top: top,
        left: left
      };
    }
  }, {
    key: "update",
    value: function update() {
      this.state.mapStart = this.absoluteOffset(this.DOM.element).top - window.innerHeight;
      this.state.transformStart = window.innerHeight / 2 * -1;
      this.state.elementHeight = this.DOM.element.getBoundingClientRect().height;

      if (this.state.elementHeight > window.innerHeight) {
        this.state.mapEnd = this.state.mapStart + window.innerHeight;
      } else {
        this.state.mapEnd = this.state.mapStart + this.state.elementHeight;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var scrollPosition = window.scrollY;
      var opacity = Math.max(Math.min(MathUtils.map(scrollPosition, this.state.mapStart, this.state.mapEnd, 0, 1), 1), 0);
      var transform = Math.max(Math.min(MathUtils.map(scrollPosition, this.state.mapStart, this.state.mapEnd, this.state.transformStart, 0), 0), this.state.transformStart);
      this.DOM.innerElement.style.opacity = opacity;
      this.DOM.innerElement.style.transform = "translate3d(0, ".concat(transform, "px, 0)");
      this.state.isTicking = false;
    }
  }, {
    key: "tick",
    value: function tick() {
      if (!this.state.isTicking) {
        requestAnimationFrame(this.render);
      }

      this.state.isTicking = true;
    }
  }]);

  return FooterAnimation;
}();

/***/ }),

/***/ 7:
/*!******************************************!*\
  !*** multi ./scripts/sections/footer.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\Users\omen\Desktop\AMQUA\amqua\scripts\sections\footer.js */"./scripts/sections/footer.js");


/***/ })

/******/ });